export var SliderCssClass;
(function (SliderCssClass) {
    SliderCssClass["Base"] = "iress-slider";
    SliderCssClass["Value"] = "iress-slider__value";
    SliderCssClass["FirstValue"] = "iress-slider__value--first";
    SliderCssClass["LastValue"] = "iress-slider__value--last";
    SliderCssClass["Input"] = "iress-slider__input";
    SliderCssClass["List"] = "iress-slider__list";
    SliderCssClass["TickMark"] = "iress-slider__tick-mark";
    SliderCssClass["TickLabel"] = "iress-slider__tick-label";
    SliderCssClass["Selected"] = "iress-slider__selected";
})(SliderCssClass || (SliderCssClass = {}));
//# sourceMappingURL=slider.types.js.map